import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./agentDatatable";
import "../invoice/wholesale-kido.css";
import "./agents-kido.css";
import { Users, Plus } from "react-feather";

import {
  getAllEmployeeRedux,
  uploadExpenseRedux,
  updateEmployeeRedux,
  uploadSourcingTransactionRedux,
} from "../../../../actions/index";

import { connect } from "react-redux";

export class Agents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fundType: "",
      totalBill: "",
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      totalPaid: 0,
      sourcingObj: null,
      type: "",
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      sourcingStatus: "",
      productDetails: "",
    };
  }

  componentDidMount = async () => {
    this.props.getAllEmployeeRedux();
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    const { currentAdmin, allEmployees } = this.props;
    const selectedEmployee = allEmployees.find(
      (employee) => employee.employeeId == this.state.agent
    );
    let date = new Date();
    if (!selectedEmployee) {
      alert("Please select agent first.");
      return;
    }
    if (this.state.customer === "") {
      alert("Please enter who you bought the fund from");
      return;
    }
    if (this.state.fundType == "") {
      alert("Select fund type first");
      return;
    }
    if (this.state.agent == "") {
      alert("Must Select giving to agent first");
      return;
    }
    if (this.state.buyRate == "") {
      alert("BuyRate cant be empty");
      return;
    }
    if (this.state.totalRmb == "") {
      alert("Total fund cant be empty");
      return;
    }
    if (this.state.totalBill == "") {
      alert("Total cash out cant be empty");
      return;
    }

    let rupeeBalance = 0;
    if (this.state.fundType == "RUPEES") {
      if (selectedEmployee.rupeeBalance) {
        rupeeBalance =
          parseInt(selectedEmployee.rupeeBalance) +
          parseInt(this.state.totalRmb);
      } else {
        rupeeBalance = parseInt(this.state.totalRmb);
      }
    } else {
      if (selectedEmployee.rupeeBalance) {
        rupeeBalance = parseInt(selectedEmployee.rupeeBalance);
      } else {
        rupeeBalance = 0;
      }
    }
    let rmbBalance = 0;
    if (this.state.fundType == "RMB") {
      if (selectedEmployee.rmbBalance) {
        rmbBalance =
          parseInt(selectedEmployee.rmbBalance) + parseInt(this.state.totalRmb);
      } else {
        rmbBalance = parseInt(this.state.totalRmb);
      }
    } else {
      if (selectedEmployee.rmbBalance) {
        rmbBalance = parseInt(selectedEmployee.rmbBalance);
      } else {
        rmbBalance = 0;
      }
    }
    // ekhane transaction add korte hobe ekhon ekta recharge hobe r jokhon kono product er taka dibe tokhon minus hobe oi figure ta.
    await this.props.uploadSourcingTransactionRedux({
      id: date.getTime().toString(),
      fundType: `${this.state.fundType}`,
      subCategory: `Bought from = ${this.state.customer}`,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Buy Rate = ${this.state.buyRate}`,
      amount: this.state.totalBill,
      totalRmb: this.state.totalRmb,
      expenseBy: currentAdmin.name,
      uid: this.state.customerUid,
      unEditable: true,
      employeeId: this.state.agent,
      rmbBalance,
      rupeeBalance,
    });
    // employee profile te gele monthly er pashapashi transaction ekta option thakbe jekhane tare koto rate te rmb/rupees fund kora hoise oita thakbe. and shekhan theke koto fund she kon invoice te khoroch korse oita entry hobe .
    await this.props.updateEmployeeRedux({
      ...selectedEmployee,
      rmbBalance,
      rupeeBalance,
    });
    await this.props.uploadExpenseRedux({
      amount: this.state.totalBill,
      category: `Buy Fund ${this.state.fundType}`,
      subCategory: `Bought from = ${this.state.customer}, Giving to =${selectedEmployee.employeeId}`,
      note: `Buy Rate = ${this.state.buyRate} Tk, Total ${this.state.fundType} =${this.state.totalRmb}`,
      date: date.toLocaleDateString("en-GB"),
      id: date.getTime().toString(),
      month: this.getMonthName(),
      receiveBy: currentAdmin.name,
      status: "pending",
      unEditable: true,
    });
    // and update in redux so that it gets live update.
    this.setState({
      fundType: "",
      totalBill: "",
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      totalPaid: 0,
      sourcingObj: null,
      type: "",
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      sourcingStatus: "",
      productDetails: "",
    });
    toast.success("New fund added to the selected agent. ");
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { allEmployees, currentAdmin } = this.props;
    const sum = (key) =>
      allEmployees.reduce((s, e) => s + (parseFloat(e[key]) || 0), 0);
    const fmt = (n) => n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
    const stats = [
      { label: "Active agents", value: allEmployees.length.toLocaleString(), tone: "sky" },
      { label: "RMB with agents", value: `¥ ${fmt(sum("rmbBalance"))}`, tone: "peach" },
      { label: "Rupees with agents", value: `₹ ${fmt(sum("rupeeBalance"))}`, tone: "mint" },
    ];
    const canBuy =
      (currentAdmin && currentAdmin.status == "Admin") ||
      (currentAdmin && currentAdmin.status == "Accounts");

    return (
      <div className="kd-ws">
        <Breadcrumb
          title="Order Agents"
          parent="Wholesale Management/Order"
        />
        <div className="container-fluid">
          <section className="card kd-orders-card">
            <div className="kd-ord-top">
              <div className="kd-ord-title">
                <span className="kd-ord-title-tile kd-st--peach" aria-hidden="true">
                  <Users size={20} />
                </span>
                <div>
                  <h2>Order agents</h2>
                  <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                    <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                  </svg>
                </div>
              </div>
              {canBuy ? (
                <div className="kd-ws-actions">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#personalInfoModal"
                    onClick={() => {
                      this.setState({
                        totalBill: "",
                        agent: "",
                        totalRmb: "",
                        sellRate: "",
                        buyRate: "",
                        productLink: "",
                        totalPaid: 0,
                        sourcingObj: null,
                        type: "upload",
                        buyingCost: 0,
                        finalProfit: 0,
                        customer: "",
                        customerUid: "",
                        cursor: -1,
                      });
                    }}
                  >
                    <Plus size={15} aria-hidden="true" />
                    Buy fund
                  </button>
                </div>
              ) : null}
            </div>

            <div className="kd-ord-summary">
              <div className="kd-ord-stats kd-ws-stats">
                {stats.map(({ label, value, tone }, i) => (
                  <div key={label} className={`kd-stat-tag kd-st--${tone}`} style={{ "--i": i }}>
                    <span className="kd-stat-label">{label}</span>
                    <span className="kd-stat-value">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="kd-ws-body" id="basicScenario">
              <Datatable
                startToggleModal={this.startToggleModal}
                history={this.props.history}
                multiSelectOption={false}
                myData={allEmployees}
                pageSize={50}
                pagination={true}
                class="-striped -highlight"
                type="expense"
              />
            </div>
          </section>
        </div>
        <ToastContainer />

        {/* Buy fund */}
        <div
          className="modal fade tb-modal"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document" style={{ margin: "auto" }}>
            <div className="modal-content" style={{ top: 10, width: "95%", margin: "auto" }}>
              <div className="modal-header">
                <div className="modal-title" id="exampleModalLabel">
                  Buy fund
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div>
                  <div className="kd-ws-form-grid">
                    <div className="form-group">
                      <label htmlFor="kd-fund-type">Fund type</label>
                      <select
                        id="kd-fund-type"
                        required
                        name="fundType"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.fundType}
                      >
                        <option value="">Select currency</option>
                        <option value="RMB">RMB</option>
                        <option value="RUPEES">Rupees</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="kd-fund-agent">Giving to</label>
                      <select
                        id="kd-fund-agent"
                        required
                        name="agent"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.agent}
                      >
                        <option value="">Select employee</option>
                        {allEmployees.map((employee) => (
                          <option key={employee.employeeId} value={`${employee.employeeId}`}>
                            {employee.name}-{employee.designation}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group is-wide">
                      <label htmlFor="kd-fund-from">Buying from</label>
                      <input
                        id="kd-fund-from"
                        type="text"
                        name="customer"
                        className="form-control"
                        placeholder="Who you bought the fund from"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.customer}
                        required
                        autoComplete="off"
                      />
                    </div>
                    {this.state.fundType && (
                      <>
                        <div className="form-group">
                          <label htmlFor="kd-fund-rate">
                            {this.state.fundType == "RUPEES" ? "Rupees" : "RMB"} buy rate
                          </label>
                          <input
                            id="kd-fund-rate"
                            type="number"
                            className="form-control"
                            name="buyRate"
                            value={this.state.buyRate}
                            onChange={this.handleChange}
                            placeholder="Buy rate in Tk"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="kd-fund-total">
                            Total {this.state.fundType == "RUPEES" ? "rupees" : "RMB"} fund
                          </label>
                          <input
                            id="kd-fund-total"
                            type="number"
                            className="form-control"
                            name="totalRmb"
                            value={this.state.totalRmb}
                            onChange={this.handleChange}
                            placeholder="Total rupees/rmb balance"
                          />
                        </div>
                      </>
                    )}
                    <div className="form-group is-wide">
                      <label htmlFor="kd-fund-cash">Total cash out</label>
                      <input
                        id="kd-fund-cash"
                        type="number"
                        className="form-control"
                        name="totalBill"
                        value={this.state.totalBill}
                        onChange={this.handleChange}
                        placeholder="Total in Taka"
                      />
                      <span className="kd-ws-hint">
                        Saved as a pending "Buy Fund" expense and added to the agent's balance.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Cash out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active"
    ),
    months: state.admins.months,
    allUsers: state.users.users,
    currentAdmin: state.admins.currentAdmin,
    sourcings: state.sourcings.sourcings,
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeRedux,
  uploadExpenseRedux,
  updateEmployeeRedux,
  uploadSourcingTransactionRedux,
})(Agents);
